import { useMsalToken } from "@/hooks/use-msal-token";
import { API_ENDPOINTS, TAG_BUILDER } from "./abstractions/api-types";
import { useAuthenticatedApi } from "./abstractions/use-authenticated-api";
import type {
  GetShiftApplicationsRequest,
  GetShiftApplicationsResponse
} from "@/domain/shifts";
import { buildHttpGet } from "@/utilities/api-utils";
import { config } from "@/config/environment";
import { DEFAULT_QUERY_OPTIONS } from "./abstractions/api-config";

// Authenticated Shifts API hook
export function useAuthenticatedShiftsApi() {
  const authenticatedApi = useAuthenticatedApi();
  const { addAuthHeader } = useMsalToken();

  const shiftsApi = authenticatedApi.injectEndpoints({
    overrideExisting: false,
    // Endpoints
    endpoints: (builder) => ({
      // Get shift applications
      getShiftApplications: builder.query<
        GetShiftApplicationsResponse,
        GetShiftApplicationsRequest
      >({
        query: async ({
          shiftId,
          professionalId,
          status,
          professionalIds
        }: GetShiftApplicationsRequest) =>
          await buildHttpGet(
            config,
            addAuthHeader,
            API_ENDPOINTS.SHIFTS.APPLICATIONS,
            { shiftId, professionalId, status, professionalIds }
          ),
        providesTags: [TAG_BUILDER.SHIFT.LIST()],
        ...DEFAULT_QUERY_OPTIONS
      })
    })
  });

  return {
    useGetShiftApplicationsQuery: shiftsApi.useGetShiftApplicationsQuery
  };
}
